<template>
<b-container fluid>
  <div class="about">
    <!--
    <b-container class="mt-5">

    <TextoIWD/>
    </b-container>

    <h2> Prácticas de la asignatura de cursos anteriores </h2>
    <article class="mt-5 mb-5">
    <TituloCursoIWD/>
    </article>
-->

    <div class="mt-5 mb-5">

     <h2>Prácticas de la asignatura
      <b-link href="https://guiadocent.udl.cat/pdf/es/102183">Web Dinámica</b-link>
     del <b-link href="http://www.graudissenydigitalitec.udl.cat/">Grado Diseño Digital y Tecnologías Creativas</b-link>
     de la <b-link href="http://www.udl.cat/">Universitat de Lleida</b-link></h2>
     <h2>Curso 2024/25</h2>  

      <p class="mt-5 mb-5 px-5 s">En este sitio web se encuentran las <strong> prácticas de los alumnos </strong> de la asignatura de Web Dinámica del   
        <b-link href="http://www.graudissenydigitalitec.udl.cat/">Grado Diseño Digital y Tecnologías Creativas</b-link> 
        del <strong> curso 2024/2025</strong>
        de la 
        <b-link href="http://www.udl.cat/">Universitat de Lleida</b-link>.
      </p>

    </div>



    <div class="mt-5 mb-5">
     <Diapos/>
    </div>

    <div class="row mt-5 mb-4">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"><strong>Práctica 1</strong></h4>
            <p class="card-text">Desarrollar una página web con HTML5 y CSS3, y elementos de diseño web.</p>
            <b-button to="/practica1" variant="primary">Accede a las prácticas <strong>1</strong></b-button>
<!--         <a href="#" class="btn btn-primary">Go somewhere</a> -->
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"><strong>Práctica 2</strong></h4>
            <p class="card-text">Construye un sitio web, utilizando  <b-link href="https://bootstrap-vue.org/">Boostrap-vue</b-link>, que combina el Framework CSS (Boostrap) y el Framework JS (VUE.js).</p>
<!--        <a href="#" class="btn btn-primary">Go somewhere</a> -->
            <b-button to="/practica2" variant="primary">Accede a las prácticas <strong>2</strong></b-button>

          </div>
        </div>
      </div>
    </div>
</div>



</b-container>
  
 
</template>

<script type="text/javascript">var _gauges = _gauges || []; (function() {var t   = document.createElement('script'); t.type  = 'text/javascript'; t.async = true; t.id    = 'gauges-tracker'; t.setAttribute('data-site-id', '59133cdabad3a70724018023'); t.setAttribute('data-track-path', 'https://track.gaug.es/track.gif'); t.src = 'https://d36ee2fcip1434.cloudfront.net/track.js'; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(t, s);})();</script>


<script>
import Diapos from '../components/Diapos.vue' 






export default {
   name: 'Home',
   components: {
        Diapos
  }
}
</script>